import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// テスト用のサンプルデータ
const TestResults: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // サンプルの基本情報
    const basicInfo = {
      name: '山田太郎',
      age: 24,
      gender: 'male',
      sport: 'サッカー',
      yearsOfExperience: 15,
      competitionLevel: 'national',
      email: 'test@example.com',
    };

    // サンプルの回答データ（全て4点で回答）
    const sampleAnswers: { questionId: string; score: number }[] = [];

    // 基本能力20問 - 各カテゴリ4問
    const basicCategories = ['team', 'goal', 'mental', 'growth', 'leader'];
    basicCategories.forEach((cat) => {
      for (let i = 1; i <= 4; i++) {
        sampleAnswers.push({
          questionId: `ba-${cat}-${i}`,
          score: 4,
        });
      }
    });

    // RIASEC 36問 - 各タイプ6問
    const riasecTypes = ['r', 'i', 'a', 's', 'e', 'c'];
    riasecTypes.forEach((type) => {
      for (let i = 1; i <= 6; i++) {
        sampleAnswers.push({
          questionId: `riasec-${type}-${i}`,
          score: 4,
        });
      }
    });

    // 仕事価値観 16問 - 各カテゴリ2問
    const valueTypes = ['economic', 'stability', 'balance', 'social', 'growth', 'relation', 'independence', 'achievement'];
    valueTypes.forEach((type) => {
      for (let i = 1; i <= 2; i++) {
        sampleAnswers.push({
          questionId: `value-${type}-${i}`,
          score: 4,
        });
      }
    });

    // ポータブルスキル 24問 - 各スキル3問
    const skillTypes = ['comm', 'present', 'nego', 'listen', 'problem', 'analysis', 'planning', 'execution'];
    skillTypes.forEach((type) => {
      for (let i = 1; i <= 3; i++) {
        sampleAnswers.push({
          questionId: `skill-${type}-${i}`,
          score: 4,
        });
      }
    });

    // 結果ページにナビゲート
    navigate('/results', {
      state: {
        basicInfo,
        answers: sampleAnswers,
      },
    });
  }, [navigate]);

  return <div>結果ページに移動中...</div>;
};

export default TestResults;
